export const exerciseOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": process.env.REACT_APP_RAPID_API_KEY,
    "X-RapidAPI-Host": "exercisedb.p.rapidapi.com",
  },
};

// export const exerciseOptions = {
//   method: "GET",
//   headers: {
//     "X-RapidAPI-Key": "67c175b16cmshc8edb4ec8f87220p186101jsnada7f9311f9d",
//     "X-RapidAPI-Host": "exercisedb.p.rapidapi.com",
//   },
// };

export const youtubeSearchOptions = {
  method: "GET",
  headers: {
    "X-RapidAPI-Key": "079cb28788mshdf0682b29d8bd51p15a106jsn0336f4cba969",
    "X-RapidAPI-Host": "youtube-search-and-download.p.rapidapi.com",
  },
};

export const fetchData = async (url, options) => {
  try {
    const response = await fetch(url, options);
    if (response.status !== 200) {
      throw new Error(response.json()?.message);
    }
    const data = await response.json();
    // console.log("the response data is", data);
    return data;
  } catch (err) {
    console.log("There was an error ", err);
  }
};
